// extracted by mini-css-extract-plugin
module.exports = {"item":"item--jHg1b","textWrap":"textWrap--1cVJC","describe":"describe--1AodN","subDescribe":"subDescribe--2fPHh","imageWrap":"imageWrap--2KrDP"};